var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Container, Card, CardFooter, CardBody, Row, Col } from 'reactstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import Signals from '../../../../signals/Signals';
import { ApplicationContext } from '../../../../ApplicationContext';
import CardTitleHeader from '../Cards/CardTitleHeader';
import CloseButton from '../CloseButton/CloseButton';
import BasicFormGroup from '../BasicFormGroup/BasicFormGroup';
import Switch from "../Switch/Switch";
/**
 *
 */
var TableSettingsOverlay = /** @class */ (function (_super) {
    __extends(TableSettingsOverlay, _super);
    /**
     *
     * @param props
     */
    function TableSettingsOverlay(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {};
        return _this;
    }
    /**
     *
     */
    TableSettingsOverlay.prototype.render = function () {
        var _a = this.props, className = _a.className, intl = _a.intl, tableModel = _a.tableModel;
        return React.createElement(Container, { className: 'table-settings-overlay w-100 ' + className },
            React.createElement(Card, { className: "bg-white" },
                React.createElement(CardTitleHeader, { title: intl.formatMessage({ id: 'table.settings.title' }) }),
                React.createElement(CardBody, null,
                    React.createElement(Row, null,
                        React.createElement(Col, { sm: 12 },
                            React.createElement(BasicFormGroup, { label: intl.formatMessage({ id: 'table.settings.label.viewtype' }), htmlFor: "compact" },
                                React.createElement(Switch, { id: "compact", checked: tableModel.compact, onChange: function () {
                                        tableModel.compact = !tableModel.compact;
                                        tableModel.updateCache();
                                    } },
                                    React.createElement(FormattedMessage, { id: "table.settings.label.viewtype.compact" })))))),
                React.createElement(CardFooter, null,
                    React.createElement("div", { className: "d-flex justify-content-end" },
                        React.createElement("button", { className: "btn btn-primary", type: "submit", onClick: function () { return Signals.HideOverlay.dispatch(); } },
                            React.createElement(FormattedMessage, { id: "page.labels.close" }))))),
            React.createElement(CloseButton, { onClick: function () {
                    Signals.HideOverlay.dispatch();
                } }));
    };
    TableSettingsOverlay.defaultProps = {
        className: ''
    };
    TableSettingsOverlay = __decorate([
        observer
    ], TableSettingsOverlay);
    return TableSettingsOverlay;
}(React.Component));
TableSettingsOverlay.contextType = ApplicationContext;
export default injectIntl(TableSettingsOverlay);
